import React, { useState } from "react";
import { Check, X } from "lucide-react";
import leaf from "../../assets/svgs/leaf.svg";

const Filter = ({
  onClose,
  vegOnly,
  setVegOnly,
  filters,
  setFilters,
  totalResults,
}) => {
  const resetFilters = () => {
    setVegOnly(false);
    setFilters({
      orders: "",
      price: "",
    });
    // setTimeout(() => {
    //   onClose();
    // }, 1000);
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/60 backdrop-blur-[2px] z-50 flex md:items-center  justify-center p-0 md:p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full sm:w-[90%] max-w-xl max-h-[100vh] rounded-none md:rounded-3xl shadow-2xl flex flex-col"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-6 border-b">
          <div className="flex items-center gap-3">
            <button onClick={onClose}>
              <X className="w-5 h-5 text-gray-800" />
            </button>

            <h1 className="font-outfit text-lg font-bold text-[#191919]">
              Filters
            </h1>
          </div>

          <button
            onClick={resetFilters}
            className="text-[#FF6943] text-sm font-medium font-manrope"
          >
            Reset All
          </button>
        </div>

        {/* Scroll area */}
        <div className="overflow-y-auto px-6 py-6 flex-1 space-y-10">
          {/* Veg toggle */}
          <div className="border border-[#D6EFDF] bg-[#F0FEF4] rounded-xl p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="bg-[#22C55E] rounded-full p-3">
                <img src={leaf} alt="veg" className="w-4 h-4" />
              </div>

              <div>
                <h1 className="text-base font-semibold text-[#191919] font-outfit">
                  Pure Veg Only
                </h1>

                <p className="text-xs text-[#717171] font-manrope">
                  Show only vegetarian tiffins
                </p>
              </div>
            </div>

            {/* Toggle */}
            <button
              onClick={() => setVegOnly(!vegOnly)}
              className={`w-11 h-6 flex items-center rounded-full transition ${
                vegOnly ? "bg-[#FF6943]" : "bg-gray-300"
              }`}
            >
              <div
                className={`bg-white w-5 h-5 rounded-full shadow-md transform transition ${
                  vegOnly ? "translate-x-5" : "translate-x-1"
                }`}
              />
            </button>
          </div>

          {/* Sort By */}
          <div className="space-y-6">
            <h1 className="text-lg font-bold text-[#191919] font-outfit">
              Sort By
            </h1>

            {/* Orders */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#191919] font-outfit text-md">
                Number of Orders
              </h3>

              <button
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    orders: prev.orders === "low_to_high" ? "" : "low_to_high", // toggle logic
                  }))
                }
                className={`w-full flex justify-between text-md font-outfit ${
                  filters.orders === "low_to_high"
                    ? "text-[#FF6943]"
                    : "text-gray-700"
                }`}
              >
                Low to High
                {filters.orders === "low_to_high" && (
                  <Check size={16} className="text-[#FF6943]" />
                )}
              </button>
              <div className="border-t border-gray-200"></div>
              <button
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    orders: prev.orders === "high_to_low" ? "" : "high_to_low", // toggle logic
                  }))
                }
                className={`w-full flex justify-between text-md font-outfit ${
                  filters.orders === "high_to_low"
                    ? "text-[#FF6943]"
                    : "text-gray-700"
                }`}
              >
                High to Low
                {filters.orders === "high_to_low" && (
                  <Check size={16} className="text-[#FF6943]" />
                )}
              </button>
            </div>

            {/* Price */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#191919] font-outfit text-md">
                Price
              </h3>

              <button
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    price: prev.price === "low_to_high" ? "" : "low_to_high", // toggle logic
                  }))
                }
                className={`w-full flex justify-between text-md font-outfit ${
                  filters.price === "low_to_high"
                    ? "text-[#FF6943]"
                    : "text-gray-700"
                }`}
              >
                Low to High
                {filters.price === "low_to_high" && (
                  <Check size={16} className="text-[#FF6943]" />
                )}
              </button>
              <div className="border-t border-gray-200"></div>
              <button
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    price: prev.price === "high_to_low" ? "" : "high_to_low", // toggle logic
                  }))
                }
                className={`w-full flex justify-between text-md font-outfit ${
                  filters.price === "high_to_low"
                    ? "text-[#FF6943]"
                    : "text-gray-700"
                }`}
              >
                High to Low
                {filters.price === "high_to_low" && (
                  <Check size={16} className="text-[#FF6943]" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Footer Button */}
        <div className="border-t p-4 bg-white sticky bottom-0 md:static">
          <button
            className="w-full bg-[#FF6943] text-white py-3 rounded-full font-normal text-[12px]"
            onClick={onClose}
          >
            Show {totalResults} Results
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filter;
